<template>
    <div :ref="id"
         :key="url"
         :id="id">
        <div ref="errorTemplate"
             style="display: none;">
            <div style="padding-left: 0.6rem; box-sizing: border-box;">
                <img :src="logo"
                     style="width: 12%; margin-left: -24px;border-radius: 4px;" />
            </div>
            <div>{{tip}}</div>
            <div>
                <a class="btn"
                   href="javascript:window.location.reload();"
                   style="color: #fff;"><i class="fa fa-refresh"></i> 立即刷新</a>
            </div>
        </div>
        <div ref="loadingTemplate"
             style="display: none; text-align: center;">
            <img :src="logo"
                 style="width: 12%; margin-left: -24px; border-radius: 4px;" />
        </div>
        <a href="javascript:;"
           class="screen"
           v-if="isTv"
           @click="getShowTv(url)">TV</a>
    </div>
</template>

<script>
import $ from "jquery"
import logo from "../assets/logo.png"
export default {
    name: "Video",
    data () {
        return {
            logo: logo,
            video: null,
            tip: '',
            isTv: false
        }
    },
    props: {
        id: String,
        url: String,
        poster: String,
        autoplay: Boolean,
        height: String,
        width: String,
        error: Function
    },
    watch: {
        url () {
            this.$nextTick(() => {
                this.createVideo()
            })
        }
    },
    mounted () {
        if (!window.videos) {
            window.videos = new Array()
        }
        this.createVideo()
    },
    methods: {
        createVideo () {
            if (this.video && this.video.video) {
                this.video.pause()
                this.video.destroy()
            }
            $("#" + this.id).find(".vcp-player").remove()

            let config = this.getCommonConfig();

            if (this.url && this.url.indexOf("m3u8") > 0) {
                config.m3u8 = this.url;
                this.tip = '哎呀~直播连接中断，刷新继续观看';
            }
            if (this.url && this.url.indexOf("mp4") > 0) {
                config.mp4 = this.url;
                this.tip = '哎呀~暂无视频内容，请稍后观看';
            }
            //投屏
            if (this.url && this.url.indexOf("mp4") > 0 && window.native_zg_handle) {
                if (window.native_zg_handle.isSupportMirror !== undefined && window.native_zg_handle.isSupportMirror()) {
                    this.isTv = true;
                }
            }

            // eslint-disable-next-line no-undef
            let video = new TcPlayer(this.id, config);

            this.video = video

            window.videos.push(video)
        },
        getShowTv (url) {
            if (window.native_zg_handle) {
                window.native_zg_handle.pushMirror(url);
            }
        },
        getCommonConfig () {
            let that = this;
            return {
                "autoplay": this.autoplay || false,
                "poster": this.poster,
                "systemFullscreen": true,
                "showLoading": true,
                "pausePosterEnabled": false,
                //"x5_type": "h5",
                "x5_playsinline": "true",
                "width": this.width,
                "height": this.height,
                "listener": function (msg) {
                    if (msg.type == 'play') {
                        that.listenVideoPlay(msg.src.options.owner)
                    } else if (msg.type == 'error') {
                        that.listenVideoPlayError()
                    } else if (msg.type == 'load') {
                        $("#" + that.id).find(".vcp-loading").html(that.$refs["loadingTemplate"].html)
                    } else if (msg.type == 'fullscreen') {
                        if (msg.detail.isFullscreen) {
                            if (window.api && typeof window.api.enterFullScreen === 'function') {
                                window.api.enterFullScreen()
                            }
                        } else {
                            if (window.api && typeof window.api.exitFullScreen === 'function') {
                                window.api.exitFullScreen()
                            }
                        }
                    }
                }
            }
        },
        listenVideoPlayError () {
            $("#" + this.id).find('.vcp-bigplay').hide()

            $("#" + this.id).find(".vcp-error-tips")
                .html(this.$refs['errorTemplate'].innerHTML)
                .off("click")
                .on("click", () => {
                    if (this.error && typeof this.error === 'function') {
                        typeof this.error()
                    }
                })
        },
        listenVideoPlay (owner) {
            window.videos.forEach((element, index) => {
                if (owner != element.options.owner) {
                    if (element.video != null) {
                        element.pause()
                    } else {
                        window.videos.splice(index, 1);
                    }
                }
            });
        }
    }
}
</script>

<style scoped>
.screen {
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
    display: block;
    border-radius: 0.1rem;
    border: 2px solid #fff;
    font-weight: bold;
    font-size: 0.32rem;
    z-index: 100;
    color: #fff;
    padding: 0 0.15rem;
}
</style>
